<template>
<router-view></router-view>
</template>

<script>
export default {
  name: 'votingStrategy'
};
</script>

<style lang="less" scoped>
</style>
